module.exports = __webpack_public_path__ + "static/media/icon_download_contract.77064179.svg";